import React, { forwardRef, Fragment, useState, useEffect } from "react";
import FormItem from "antd/es/form/FormItem";
import Title from 'antd/es/typography/Title';
import Paragraph from 'antd/es/typography/Paragraph';
import { Typography } from 'antd';
import Input from "antd/es/input/Input";
import TranslatedText from "translations/TranslatedText";
import Button from "antd/es/button/button";
import SentenceComponent from './SentenceComponent';
import SyntaxComponent from './SyntaxComponent';
import cloneDeep from "lodash.clonedeep";
import { trimText, normalizeText } from 'lib'
import unescape from "lodash/unescape";

const correctAnswerStyle = {
  color: '#1C9E11',
}

const incorrectAnswerStyle = {
  color: '#DB2728',
  textDecoration: 'line-through',
}

export default forwardRef((props: any, ref: any) => {
  const { form, inputData, questionsKey, language,
          onCheckAnswer, checkAnswer, } = props,
    { required, questions, id, defaultValue, sentences: allSentences } = inputData,
    { getFieldDecorator } = form;
  const [responses, setResponses] = useState([]);
  const [localSentences, setLocalSentences] = useState(allSentences[language]);
  const correctAnswers = allSentences.correctAnswers;
  const dangerouslySetInnerHTML = unescape(questions[language]);
  const usingSyntaxConfig = allSentences.syntaxConfig;

  const hasCorrectAnswers = (value, index) => {
    if (!value) return false

    const valueNormal = trimText(value) // user can check answer without an attempt
    const hanziNormal = correctAnswers.hanzi.reduce(normalizeText).split('/')
    const pinyinNormal = correctAnswers.pinyin.reduce(normalizeText).split('/')

    return hanziNormal.includes(valueNormal) ||
           pinyinNormal.includes(valueNormal)
  }

  useEffect(() => {
    if (checkAnswer) {
      onCheckAnswer(id, responses, questionsKey);
    }
  }, [checkAnswer]);

  useEffect(() => {
    setLocalSentences(allSentences[language]);
  }, [allSentences]);

  return (
    <FormItem
      style={{ textAlign: "center" }}
      colon={false}
    >
      {getFieldDecorator(id, {
        initialValue: defaultValue,
        rules: [
          {
            required,
            message: "Required Field"
          }
        ]
      })(
        <Fragment>
        {
          usingSyntaxConfig ?
          <SyntaxComponent blanks={allSentences.blanks}
                           questions={dangerouslySetInnerHTML}
                           onSetBlank={(blank) => setResponses(blank)}
                           checkAnswer={checkAnswer}
          /> :
          <Title level={2}>
            {
              localSentences.map((sentence, index) => {
                return (
                  <Fragment key={index}>
                    <SentenceComponent
                      letterIndex={index}
                      sentence={{...sentence, blank: responses}}
                      onSetBlank={(blank) => setResponses(blank)}
                      checkAnswer={checkAnswer}
                      hasCorrectAnswers={hasCorrectAnswers}
                      correctAnswers={correctAnswers}
                    />
                  </Fragment>
                )
              })
            }
          </Title>
        }
        </Fragment>
      )}
    </FormItem>
  );
});
